/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Floating_Compare_With_Another_SpaceInputs */



/**
* | output |
* | --- |
* | "Compare with another space" |
*
* @param {Spaces_Floating_Compare_With_Another_SpaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_floating_compare_with_another_space = /** @type {((inputs?: Spaces_Floating_Compare_With_Another_SpaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Floating_Compare_With_Another_SpaceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mit einem anderen Space vergleichen")
	return /** @type {LocalizedString} */ ("Compare with another space")
});